
import Vue from "vue";

export default Vue.extend({
  props: {
    error: {
      type: Boolean,
      default: false,
      required: false,
    },
    errorMsg: {
      type: String,
      default: null,
      required: false,
    },
  },
  methods: {
    handleClic() {
      setTimeout(() => {
        this.$router.push("/worker/signaletic");
      }, 0o10);
      this.$modal.close();
    },
  },
});
